import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { map, Observable, startWith } from 'rxjs';
import { BasketSummaryComponent } from 'src/app/checkout-page/components/basket-summary/basket-summary.component';
import { BasketService } from 'src/app/checkout-page/services/basket.service';
import { BasketReturnModel, Money } from 'src/business/services/client.generated';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PricePipe } from 'src/core-lib/pipes/price.pipe';
import { MediaModule } from 'src/layout/media/media.module';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { ContentCacheUtils } from 'src/utils/storage.util';

declare interface Basket {}
@Component({
    selector: 'app-overlay-basket',
    templateUrl: './overlay-basket.component.html',
    styleUrls: ['./overlay-basket.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        BasketSummaryComponent,
        MediaModule,
        NavigationModule,
        TranslateModule,
        CommonModule,
        PricePipe,
    ]
})
export class OverlayBasketComponent {
    basket$: Observable<BasketReturnModel>;
    quantity$: Observable<number>;
    total$: Observable<Money>;
    basketLink: string;

    constructor(
        private overlayService: OverlayService,
        private basketService: BasketService,
        ) {
            this.basketLink = ContentCacheUtils.checkout<{ basketPageLink: string }>()?.basketPageLink
            this.basket$ = this.basketService.basket$
            this.quantity$ = this.basket$.pipe(map(basket => basket?.quantity ?? 0), startWith(0));
            this.total$ = this.basket$.pipe(map(basket => basket?.total));
        }

    closeOverLay() {
        this.overlayService.close();
    }
}
